import React from 'react'
import { createListCollection } from '@chakra-ui/react'
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText
} from '@/components/ui/select'
import { UserChip } from '.'

export default ({ bg, size, multiple, placeholder, selectedUsers, users, onChosen }) => {
  const options = createListCollection({
    items: users,
    itemToString: (u) => u.email,
    itemToValue: (u) => u._id
  })

  return (
    <SelectRoot collection={options} bg={bg} size={size} multiple={multiple} deselectable={!multiple} onValueChange={e => onChosen(e.value)} value={selectedUsers || []}>
      <SelectTrigger>
        <SelectValueText placeholder={placeholder || 'Select someone'} p={1}>
          {(selectedUsers) => {
            if (selectedUsers.length === 0) return placeholder || 'Select someone'
            if (selectedUsers.length === 1) return <UserChip compact user={selectedUsers[0]} />
            return `${selectedUsers.length} selected`
          }}
        </SelectValueText>
      </SelectTrigger>
      <SelectContent portalled={false}>
        {options?.items?.map((option) => (
          <SelectItem item={option} key={option._id}>
            <UserChip compact user={option} />
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  )
}
